/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Lock
 * @desc Action to toggle lock for experimentWorkflow
 */

import { EntityActionLockContainer as EntityActionLock } from 'labstep-web/components/Entity/Action/Lock';
import type React from 'react';
import type { ExperimentWorkflowActionLockProps } from './types';

export const ExperimentWorkflowActionLock: React.FC<
  ExperimentWorkflowActionLockProps
> = ({ experimentWorkflow, options = {}, actionComponentProps }) => (
  <EntityActionLock
    dataCy="components/ExperimentWorkflow/Action/Lock"
    entity={experimentWorkflow}
    options={options}
    actionComponentProps={actionComponentProps}
  />
);
